import { inject, Navigator, needs, type RouterConfig, prop } from "fw";
import { CurrentUserStore } from "state/current-user";
import { resetAllOnce } from "helpers/once";
import { dispatch } from "fw-state";
import { LogoutAction } from "state/actions";
import { UserType } from "models/user";
import { MyAccountModal } from "../myaccount/my-account-modal";
import { NotificationsStore } from "state/notifications";

type Module = { routePath: string; module: string };
const MODULES: Module[] = [
    { routePath: "home", module: "Global Search" },
    { routePath: "organizations", module: "Organizations" },
    { routePath: "settings", module: "Settings" },
    { routePath: "monitor", module: "Monitoring" },
    { routePath: "organization-templates", module: "Organization Templates" }
];

@inject
@needs(MyAccountModal)
export class AdmissionsHeader {
    @prop(null) router: RouterConfig;

    private isMyAccountModalOpen: boolean = false;
    private profilePopoverOpen: boolean = false;
    private notificationsInterval: any = null;

    constructor(
        private currentUser: CurrentUserStore,
        private nav: Navigator,
        private store: NotificationsStore
    ) {}

    get currentRoutePath() {
        const [firstPath] = this.router.fullLocation.split("/");
        return firstPath.toLowerCase() || "home";
    }

    get currentModule() {
        if (this.router !== null) {
            return MODULES.find((item) => item.routePath === this.currentRoutePath)?.module;
        }

        return this.currentRoutePath;
    }

    openMyAccountModal() {
        this.profilePopoverOpen = false;
        this.isMyAccountModalOpen = true;
    }

    closeMyAccountModal() {
        this.isMyAccountModalOpen = false;
    }

    async logout() {
        // reset the lazy load tracking for all states
        resetAllOnce();
        await dispatch(new LogoutAction());

        if (this.notificationsInterval) clearInterval(this.notificationsInterval);

        this.nav.navigate("/login");
    }

    get loggedIn() {
        if (this.currentUser.state.loggedIn) {
            if (this.currentUser.state.user == null || this.currentUser.state.token == null) {
                // invalid state: force logout
                this.logout();
            } else {
                return true;
            }
        }
        return false;
    }

    get isSystemAdministrator() {
        return this.currentUser.state?.user.Type == UserType.SystemAdministrator;
    }

    get isAdministrator() {
        const userType = this.currentUser.state.user.Type;
        return userType == UserType.SystemAdministrator || userType == UserType.GlobalAdministrator;
    }

    get notificationsTotal() {
        return this.store.state.alarmsNotifications?.Total;
    }

    get notificationsAnimation() {
        return this.store.state.alarmsNotificationsAnimation;
    }

    public get canViewNavigation(): boolean {
        switch (this.currentUser.state.user.Type) {
            case UserType.TransferPlannerAPIService:
                return false;
            default:
                return true;
        }
    }
}
